import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  EquipmentModelIntegrationCodeData,
  EquipmentModelIntegrationCodeResponse,
} from '@/features/equipmentModels/types/equipmentModelIntegrationCode'
import { Query, UseQueryResult, useQuery } from '@tanstack/react-query'

type UseEquipmentModelIntegrationCodeProps = {
  id?: string
  enabled?: boolean
  refetchInterval?:
    | number
    | false
    | ((
        query: Query<EquipmentModelIntegrationCodeResponse, unknown, EquipmentModelIntegrationCodeResponse>,
      ) => number | false | undefined)
}

export const useEquipmentModelIntegrationCode = ({
  id,
  enabled = true,
  refetchInterval = false,
}: UseEquipmentModelIntegrationCodeProps): UseQueryResult<EquipmentModelIntegrationCodeData, unknown> => {
  const privateAxios = usePrivateAxios()

  return useQuery<EquipmentModelIntegrationCodeResponse, unknown, EquipmentModelIntegrationCodeData>({
    queryKey: ['equipmentModelIntegrationCode', id],
    queryFn: () => privateAxios.get(`/maintenance/equipment_model_integration_codes/${id}`),
    select: (data) => data?.data?.data,
    enabled: enabled && !!id,
    refetchInterval,
  })
}
